import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'
import { ListTable } from 'gnos-tables'

import { createListTableId } from '../../../../../../helpers'

import config from '../../../../../../../../../config'

import BisnodeScoring from '../../BisnodeScoring'
import PaymentComparision from '../../PaymentComparison'
import BlockTable from '../../../../../../../components/Workspace/components/BlockTable'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import { LOCALE_PREFIX } from './constants'

const listTableUrlByLocale = {
    cz: 'https://www.mocky.io/v2/5b0ba1a02f00007f00ec4d57',
    en: 'https://www.mocky.io/v2/5b0bc0143300006900b3fd46',
    sk: 'https://www.mocky.io/v2/5b0bc0333300007200b3fd48',
}

@hocBlock(config.modules.report.key)
@injectIntl
export default class Identification extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        locale: PropTypes.string.isRequired,
        transformedData: PropTypes.array,
        intl: PropTypes.object,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (this.props.locale !== nextProps.locale) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true
        if (this.props.block !== nextProps.block) return true

        return false
    }

    renderDue = (dueDays) => <FormattedMessage id={`${LOCALE_PREFIX}.due`} values={{ dueDays }} />

    render() {
        const {
            block,
            id,
            level,
            locale,
            transformedData,
            intl: { formatMessage },
        } = this.props

        return (
            <div className={cx('block-identification')}>
                <br /> <br />
                {'Scoring'}
                <br /> <br />
                <BisnodeScoring
                    data={transformedData}
                    legend={transformedData}
                    translates={{
                        degreeLabel: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.degreeLabel` }),
                        descriptionLabel: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.descriptionLabel` }),
                        probabilityLabel: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.probabilityLabel`}
                                values={{ br: <br /> }}
                            />
                        ),
                        terminologyToggleText: formatMessage({
                            id: `${LOCALE_PREFIX}.bisnodeScoring.terminologyToggleText`,
                        }),
                        terminologyScoringText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyScoringText`}
                                values={{
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    privCz: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    privSk: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        terminologyKreditText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyKreditText`}
                                values={{
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    privCz: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    privSk: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        terminologyTransactionText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyTransactionText`}
                                values={{
                                    strong: (chunks) => <strong>{chunks}</strong>,
                                    privCz: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                    privSk: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="link"
                                            href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        terminologyLimitsText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.terminologyLimitsText`}
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        ),
                        creditsLimitText: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.creditsLimitText` }),
                        transactionsLimitText: formatMessage({
                            id: `${LOCALE_PREFIX}.bisnodeScoring.transactionsLimitText`,
                        }),
                        criteriaText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.criteriaText`}
                                values={{
                                    a: (chunks) => (
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="http://www.eulerhermes.cz/"
                                            className="link"
                                        >
                                            {chunks}
                                        </a>
                                    ),
                                }}
                            />
                        ),
                        criteriaTitleText: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.criteriaTitleText` }),
                        refreshText: <FormattedMessage id={`${LOCALE_PREFIX}.bisnodeScoring.refreshText`} />,
                        lastChangeText: formatMessage({ id: `${LOCALE_PREFIX}.bisnodeScoring.lastChangeText` }),
                        yearOfFinancialStatements: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bisnodeScoring.yearOfFinancialStatements`}
                                values={{ year: transformedData?.summary?.data?.financialStatementsYear }}
                            />
                        ),
                        noData: <FormattedMessage id={`${LOCALE_PREFIX}.noData`} />,
                    }}
                />
                <br />
                <br />
                PAYMENT COMPARISION
                <br />
                <br />
                <PaymentComparision
                    data={transformedData}
                    legend={transformedData}
                    translates={{
                        p12label: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.paymentComparision.p12label`}
                                values={{ br: <br /> }}
                            />
                        ),
                        p12sectorLabel: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.paymentComparision.p12sectorLabel`}
                                values={{ br: <br /> }}
                            />
                        ),
                        dueLabel: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.paymentComparision.dueLabel`}
                                values={{ br: <br /> }}
                            />
                        ),
                        description: <FormattedMessage id={`${LOCALE_PREFIX}.paymentComparision.description`} />,
                        interval: <FormattedMessage id={`${LOCALE_PREFIX}.paymentComparision.interval`} />,
                        p12sectorText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.paymentComparision.p12sectorText`}
                                values={{ br: <br /> }}
                            />
                        ),
                        selfColumnText: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.paymentComparision.selfColumnText`}
                                values={{ br: <br /> }}
                            />
                        ),
                        partnersColumnText: (
                            <FormattedMessage id={`${LOCALE_PREFIX}.paymentComparision.partnersColumnText`} />
                        ),
                        clubColumnText: <FormattedMessage id={`${LOCALE_PREFIX}.paymentComparision.clubColumnText`} />,
                    }}
                />
                <br />
                <br />
                IDENTIFICATION
                <br />
                <br />
                <ListTable
                    id={createListTableId(config.modules.report.key, id, block)}
                    columnsDefinition={{
                        title: {
                            width: 150,
                            Cell: ({ isNested, text }) => (
                                <span style={{ fontWeight: 'bold', color: isNested ? '#b3b3b3' : '#000000' }}>
                                    {text}
                                </span>
                            ),
                        },
                        top: {
                            visibleRows: 4,
                            stepRows: 4,
                            columns: [
                                {
                                    accessor: 'regNbr',
                                    width: 115,
                                    Cell: ({ value }) => <span style={{ color: 'red' }}>{value}</span>,
                                },
                                {
                                    accessor: 'addr',
                                },
                            ],
                        },
                        nested: {
                            visibleRows: 4,
                            stepRows: 4,
                            columns: [
                                {
                                    accessor: 'regNbr',
                                    width: 115,
                                    Cell: ({ value }) => <span style={{ color: 'blue' }}>{value}</span>,
                                },
                                {
                                    accessor: 'addr',
                                },
                                {
                                    accessor: 'from',
                                    width: 90,
                                    order: 'desc',
                                    Header: 'Od',
                                },
                                {
                                    accessor: 'to',
                                    width: 90,
                                    order: 'asc',
                                    Header: 'Do',
                                },
                            ],
                        },
                    }}
                    contextMenu={({ rowData }) => (
                        <div style={{ padding: '10px 20px', background: 'beige' }}>{_.get(rowData, 'row.regNbr')}</div>
                    )}
                    uriSettings={{
                        uri: listTableUrlByLocale[config.languages[locale].requestKey],
                        qs: { lang: locale, level, 'mocky-delay': '1000ms' },
                    }}
                    urlSettingsReloadPaths={[{ path: 'qs.level', reset: true }, { path: 'qs.lang' }]}
                    responsePath={'payload.response.body'}
                />
                <BlockTable
                    tableId={`${config.modules.report.key}_${block}_${id}_blockTable`}
                    data={transformedData}
                    level={level}
                />
            </div>
        )
    }
}
